
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import Stack from '@mui/material/Stack';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import LanguageCard from 'pages/wiki-detail/embedded-item/language';
import MarkdownViewer from 'components/atomic/organisms/markdown-viewer';
import CourseCard from 'components/atomic/molecules/course-card';
import PathCard from 'components/atomic/molecules/path-card';
import MainLayout from 'components/layouts/main-layout';
import RightPanel from 'pages/wiki-detail/right-panel';
import ItemList from 'pages/wiki-detail/item-list';
import Hero from 'pages/wiki-detail/hero';
import { Tool as ToolType } from 'types/wiki';
import Routes, { toAbsoluteUrl } from 'utils/routes';
import devvSdk from 'utils/devv-sdk';
const SEO = ({ tool }: {
    tool: ToolType;
}) => {
    const router = useRouter();
    const keywords = [
        'linguaggio di programmazione',
        'linguaggio di markup',
        'linguaggio di scripting',
        ...tool.categoriesTitles,
    ];
    const OGTitle = `${tool.title}: scopri tutti i segreti!`;
    const description = `Cos'è ${tool.title}? A cosa serve? Scopri tutti i segreti di ${tool.title}: 
${tool.description}`;
    return (<>
            <NextSeo title={tool.title} titleTemplate={`Cos'è %s e a cosa serve? | Devv`} description={description} canonical={`${toAbsoluteUrl(router.asPath)}`} additionalMetaTags={[
            {
                property: 'keywords',
                content: keywords.join(', '),
            },
        ]} openGraph={{
            url: `${toAbsoluteUrl(router.asPath)}`,
            images: [
                {
                    url: Routes.OGImageTitleCTA(OGTitle, 'DEVV WIKI'),
                    secureUrl: Routes.OGImageTitleCTA(OGTitle, 'DEVV WIKI'),
                    type: 'image/png',
                    width: 1200,
                    height: 630,
                },
            ],
        }}/>
            <BreadcrumbJsonLd itemListElements={[
            {
                position: 1,
                name: 'Wiki',
                item: `${toAbsoluteUrl(Routes.Wiki)}`,
            },
            {
                position: 2,
                name: 'Strumenti per programmatori',
                item: `${toAbsoluteUrl(Routes.WikiLanguages)}`,
            },
            {
                position: 3,
                name: tool.title,
                item: `${toAbsoluteUrl(Routes.WikiTool(tool.slug))}`,
            },
        ]}/>
        </>);
};
interface ToolPageProps {
    tool: ToolType;
}
const Tool: NextPage<ToolPageProps> = ({ tool }) => {
    return (<>
            <SEO tool={tool}/>
            <MainLayout isFluid>
                <Hero title={tool.title} description={tool.description} logo={tool.logo} categoriesTitles={tool.categoriesTitles} breadcrumbs={[
            {
                title: 'Wiki',
                href: undefined,
            },
            {
                title: 'Tools',
                href: Routes.WikiTools,
            },
            {
                title: tool.title,
                href: undefined,
            },
        ]} color="#39916d"/>

                <ResponsiveContainer maxWidth={'lg'}>
                    <Stack direction={'row'} paddingY={2}>
                        <Stack flexGrow={1}>
                            <MarkdownViewer>{tool.body}</MarkdownViewer>

                            {tool.courses.length ? (<ItemList title={`Corsi di ${tool.title}`} items={tool.courses} itemColumns={{ xs: 12, sm: 6, md: 4, lg: 6 }} mt={4} renderItem={(item) => <CourseCard {...item}/>}/>) : null}

                            {tool.paths.length ? (<ItemList title={`Percorsi di ${tool.title}`} items={tool.paths} mt={4} itemColumns={{ xs: 12, sm: 6, md: 4, lg: 6 }} renderItem={(item) => <PathCard {...item}/>}/>) : null}

                            {tool.languages.length ? (<ItemList title={`Linguaggi usati in ${tool.title}`} items={tool.languages} mt={4} itemColumns={{ xs: 12, sm: 6, md: 4, lg: 6 }} renderItem={(item) => <LanguageCard item={item}/>}/>) : null}
                        </Stack>

                        <RightPanel />
                    </Stack>
                </ResponsiveContainer>
            </MainLayout>
        </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    const { data } = await devvSdk.getToolsOverview();
    return {
        paths: data.map((el) => ({
            params: { slug: el.slug },
        })),
        fallback: false,
    };
};
const getStaticProps: GetStaticProps<ToolPageProps> = async ({ params }) => {
    if (!params || !params.slug) {
        return { redirect: { destination: Routes.WikiTools, permanent: false } };
    }
    const { data: tool } = await devvSdk.getToolBySlug(params.slug as string);
    return {
        props: {
            tool,
        },
    };
};
export default Tool;

    async function __Next_Translate__getStaticProps__18916ceb309__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/wiki/tools/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb309__ as getStaticProps }
  